var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtectionRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.86667V0.2H9.56667V0.988889C9.81111 0.662963 10.1111 0.418519 10.4667 0.255556C10.8222 0.0851852 11.1963 0 11.5889 0C11.9963 0 12.3778 0.0888888 12.7333 0.266666C13.0889 0.437037 13.3852 0.688889 13.6222 1.02222C13.8815 0.688889 14.2074 0.437037 14.6 0.266666C14.9926 0.0888888 15.4148 0 15.8667 0C16.3481 0 16.7963 0.111111 17.2111 0.333333C17.6259 0.555556 17.963 0.877778 18.2222 1.3C18.4815 1.72222 18.6111 2.22963 18.6111 2.82222V6.86667H16.8556V3.06667C16.8556 2.64444 16.7333 2.29259 16.4889 2.01111C16.2519 1.72963 15.9296 1.58889 15.5222 1.58889C15.2926 1.58889 15.0741 1.64074 14.8667 1.74444C14.6593 1.84815 14.4926 2.00741 14.3667 2.22222C14.2407 2.43704 14.1778 2.71111 14.1778 3.04444V6.86667H12.4222V3.06667C12.4222 2.78519 12.3667 2.53333 12.2556 2.31111C12.1444 2.08148 11.9889 1.9037 11.7889 1.77778C11.5889 1.64444 11.3556 1.57778 11.0889 1.57778C10.8667 1.57778 10.6519 1.63333 10.4444 1.74444C10.237 1.84815 10.0667 2.00741 9.93333 2.22222C9.80741 2.43704 9.74444 2.71111 9.74444 3.04444V6.86667H8Z",
    fill: "#FF0953"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12H0V10H24V12Z",
    fill: "#FF0953"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 17L24 5L26 5L26 17L24 17Z",
    fill: "#FF0953"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24537e-07 17L0 5L2 5L2 17L5.24537e-07 17Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectionRange);
export default __webpack_public_path__ + "static/media/protection_range.6f84c718dc4f5072fc97bed67a98474a.svg";
export { ForwardRef as ReactComponent };